"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerAccountGroup = exports.LedgerAccountGroupIterable = exports.TransactionType = exports.TransactionTypeIterable = exports.TAccountIterable = exports.ExpenseAccounts = exports.ExpenseAccountsIterable = exports.CurrentLiabilityAccounts = exports.CurrentLiabilityAccountsIterable = exports.LongTermLiabilityAccounts = exports.LongTermLiabilityAccountsIterable = exports.EquityAccounts = exports.EquityAccountsIterable = exports.LongTermAssetAccounts = exports.LongTermAssetAccountsIterable = exports.CurrentAssetAccounts = exports.CurrentAssetAccountsIterable = exports.AccountSubCategories = exports.AccountSubCategoriesIterable = exports.AccountCategories = exports.AccountCategoriesIterable = void 0;
/**
 * Account definitions
 *
 * Fundamental equation:
 * Assets = Liabilities + Equity
 */
// Unused, but keeping definition
exports.AccountCategoriesIterable = [
    'liability',
    'asset',
    'equity',
];
exports.AccountCategories = {
    Liability: 'liability',
    Asset: 'asset',
    Equity: 'equity',
};
// Unused, but keeping definition
exports.AccountSubCategoriesIterable = [
    'shortTermLiability',
    'longTermLiability',
];
exports.AccountSubCategories = {
    CurrentLiability: 'shortTermLiability',
    LongTermLiability: 'longTermLiability',
};
exports.CurrentAssetAccountsIterable = ['cash'];
exports.CurrentAssetAccounts = {
    Cash: 'cash',
};
/**
 * This account tracks the principal amount that the Lender owes to the
 * Admin Agent as they fronted their amount for a draw.
 *
 * Treating as "Long Term" to follow suit with its counter part of
 * "AdminAgentPrincipalPayable" (comments below for context).
 */
exports.LongTermAssetAccountsIterable = [
    'adminAgentPrincipalReceivable',
];
exports.LongTermAssetAccounts = {
    AdminAgentPrincipalReceivable: 'adminAgentPrincipalReceivable',
};
exports.EquityAccountsIterable = ['shareholdersEquity'];
exports.EquityAccounts = {
    ShareholdersEquity: 'shareholdersEquity',
};
/**
 * LongTermDebt: Standard long term debt account
 *
 * AdminAgentPrincipalPayable: This account tracks the principal amount that the Admin Agent fronts
 * for a lender, as a lender may not instantly provide the funds for a draw.
 * It's important to include this account as part of "Principal Balance"
 * since this balance basically reflects the "long term debt" that the
 * lender has the Admin Agent fronting for them.
 *
 * Our "current" accounts don't follow typical accounting standards, so
 * while we expect to pay this account off within a year, this account doesn't
 * have an associated "expense" account, which is what we generally treat our
 * current accounts for.
 */
exports.LongTermLiabilityAccountsIterable = [
    'longTermDebt',
    'adminAgentPrincipalPayable',
];
exports.LongTermLiabilityAccounts = {
    LongTermDebt: 'longTermDebt',
    AdminAgentPrincipalPayable: 'adminAgentPrincipalPayable',
};
exports.CurrentLiabilityAccountsIterable = [
    'accruedAccountBankFee',
    'accruedAdminAgentFee',
    'accruedAdminAgentSkimFee',
    'accruedAdminFee',
    'accruedBackupServicingFee',
    'accruedCollateralAgentFee',
    'accruedCollateralManagementFee',
    'accruedCollectionAccountFee',
    'accruedCommitmentFee',
    'accruedCustodianFee',
    'accruedDrawFee',
    'accruedInterest',
    'accruedIndentureTrusteeFee',
    'accruedOriginationFee',
    'accruedOtherFee',
    'accruedPayingAgentFee',
    'accruedServicingFee',
    'accruedTrustAccountFee',
    'accruedUnusedInterest',
    'accruedUtilizationAdditionalInterest',
    'accruedVerificationAgentFee',
];
exports.CurrentLiabilityAccounts = {
    AccruedAccountBankFee: 'accruedAccountBankFee',
    AccruedAdminAgentFee: 'accruedAdminAgentFee',
    AccruedAdminAgentSkimFee: 'accruedAdminAgentSkimFee',
    AccruedAdminFee: 'accruedAdminFee', // General administration fee
    AccruedBackupServicingFee: 'accruedBackupServicingFee',
    AccruedCollateralAgentFee: 'accruedCollateralAgentFee',
    AccruedCollateralManagementFee: 'accruedCollateralManagementFee',
    AccruedCollectionAccountFee: 'accruedCollectionAccountFee',
    AccruedCommitmentFee: 'accruedCommitmentFee',
    AccruedCustodianFee: 'accruedCustodianFee',
    AccruedDrawFee: 'accruedDrawFee',
    AccruedInterest: 'accruedInterest',
    AccruedIndentureTrusteeFee: 'accruedIndentureTrusteeFee',
    AccruedOriginationFee: 'accruedOriginationFee',
    AccruedOtherFee: 'accruedOtherFee',
    AccruedPayingAgentFee: 'accruedPayingAgentFee',
    AccruedServicingFee: 'accruedServicingFee',
    AccruedTrustAccountFee: 'accruedTrustAccountFee',
    AccruedUnusedInterest: 'accruedUnusedInterest',
    AccruedUtilizationAdditionalInterest: 'accruedUtilizationAdditionalInterest',
    AccruedVerificationAgentFee: 'accruedVerificationAgentFee',
};
exports.ExpenseAccountsIterable = [
    'accountBankFeeExpense',
    'adminAgentFeeExpense',
    'adminFeeExpense',
    'adminAgentSkimFeeExpense',
    'backupServicingFeeExpense',
    'collateralAgentFeeExpense',
    'collateralManagementFeeExpense',
    'collectionAccountFeeExpense',
    'commitmentFeeExpense',
    'custodianFeeExpense',
    'drawFeeExpense',
    'interestExpense',
    'indentureTrusteeFeeExpense',
    'originationFeeExpense',
    'otherFeeExpense',
    'payingAgentFeeExpense',
    'servicingFeeExpense',
    'trustAccountFeeExpense',
    'unusedInterestExpense',
    'utilizationAdditionalInterestExpense',
    'verificationAgentFeeExpense',
];
exports.ExpenseAccounts = {
    AccountBankFeeExpense: 'accountBankFeeExpense',
    AdminAgentFeeExpense: 'adminAgentFeeExpense',
    AdminFeeExpense: 'adminFeeExpense',
    AdminAgentSkimFeeExpense: 'adminAgentSkimFeeExpense',
    BackupServicingFeeExpense: 'backupServicingFeeExpense',
    CollateralAgentFeeExpense: 'collateralAgentFeeExpense',
    CollateralManagementFeeExpense: 'collateralManagementFeeExpense',
    CollectionAccountFeeExpense: 'collectionAccountFeeExpense',
    CommitmentFeeExpense: 'commitmentFeeExpense',
    CustodianFeeExpense: 'custodianFeeExpense',
    DrawFeeExpense: 'drawFeeExpense',
    InterestExpense: 'interestExpense',
    IndentureTrusteeFeeExpense: 'indentureTrusteeFeeExpense',
    OriginationFeeExpense: 'originationFeeExpense',
    OtherFeeExpense: 'otherFeeExpense',
    PayingAgentFeeExpense: 'payingAgentFeeExpense',
    ServicingFeeExpense: 'servicingFeeExpense',
    TrustAccountFeeExpense: 'trustAccountFeeExpense',
    UnusedInterestExpense: 'unusedInterestExpense',
    UtilizationAdditionalInterestExpense: 'utilizationAdditionalInterestExpense',
    VerificationAgentFeeExpense: 'verificationAgentFeeExpense',
};
exports.TAccountIterable = [
    ...exports.CurrentAssetAccountsIterable,
    ...exports.CurrentLiabilityAccountsIterable,
    ...exports.LongTermLiabilityAccountsIterable,
    ...exports.LongTermAssetAccountsIterable,
    ...exports.EquityAccountsIterable,
    ...exports.ExpenseAccountsIterable,
];
/**
 * Transactions and entries
 */
exports.TransactionTypeIterable = [
    'collectionsRecycle',
    'collectionsPaydown',
    'curePaydown',
    // Interest related transactions
    'dailyAccrual',
    'reverseInterestAccrual',
    'decreaseCurrentLiability',
    'decreaseExpensePayment',
    'decreaseOutstandingLoanBalance',
    'drawRequest',
    'expensePayment',
    'increaseCurrentLiability',
    'increaseExpensePayment',
    'increaseOutstandingLoanBalance',
    'reconciliationAdjustment',
    'zeroCurrentLiabilities',
    'transferPrincipalBalance',
    // Invoice related transactions
    'invoiceLoanPayment',
    'reverseInvoiceLoanPayment',
    'interestCapitalization',
    'reverseInterestCapitalization',
    'invoiceFacilityPayment',
    'reverseInvoiceFacilityPayment',
    // Admin Agent fronting transactions
    'adminAgentPrincipalLending',
    'adminAgentPrincipalPaydown',
    'reverseAdminAgentPrincipalPaydown',
];
exports.TransactionType = {
    CollectionsRecycle: 'collectionsRecycle',
    CollectionsPaydown: 'collectionsPaydown',
    CurePaydown: 'curePaydown',
    // Interest related transactions
    DailyAccrual: 'dailyAccrual',
    ReverseInterestAccrual: 'reverseInterestAccrual',
    DecreaseCurrentLiability: 'decreaseCurrentLiability',
    DecreaseExpensePayment: 'decreaseExpensePayment',
    DecreaseOutstandingLoanBalance: 'decreaseOutstandingLoanBalance',
    DrawRequest: 'drawRequest',
    ExpensePayment: 'expensePayment',
    IncreaseCurrentLiability: 'increaseCurrentLiability',
    IncreaseExpensePayment: 'increaseExpensePayment',
    IncreaseOutstandingLoanBalance: 'increaseOutstandingLoanBalance',
    ReconciliationAdjustment: 'reconciliationAdjustment',
    ZeroCurrentLiabilities: 'zeroCurrentLiabilities',
    TransferPrincipalBalance: 'transferPrincipalBalance',
    // Invoice related transactions
    InvoiceLoanPayment: 'invoiceLoanPayment',
    ReverseInvoiceLoanPayment: 'reverseInvoiceLoanPayment',
    InterestCapitalization: 'interestCapitalization',
    ReverseInterestCapitalization: 'reverseInterestCapitalization',
    InvoiceFacilityPayment: 'invoiceFacilityPayment',
    ReverseInvoiceFacilityPayment: 'reverseInvoiceFacilityPayment',
    /**
     * Transactions related to Admin Agent fronting money for the loan's
     * lender during a draw request
     */
    AdminAgentPrincipalLending: 'adminAgentPrincipalLending',
    AdminAgentPrincipalPaydown: 'adminAgentPrincipalPaydown',
    ReverseAdminAgentPrincipalPaydown: 'reverseAdminAgentPrincipalPaydown',
};
exports.LedgerAccountGroupIterable = [
    'outstandingLedger',
    'expensesFees',
];
exports.LedgerAccountGroup = {
    OutstandingLedger: 'outstandingLedger',
    ExpensesFees: 'expensesFees',
};
//# sourceMappingURL=Accounting.js.map